export default "__VITE_ASSET__DEzCfunO__"